import { ButtonGroup, IconButton, Pagination } from '@chakra-ui/react';
import { useState } from 'react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import { useATPageIndex, useATPageSize } from '../hooks';

const ATPagination = ({ totalItemsCount }: { totalItemsCount: number }) => {
  const { pageIndex, setPageIndex } = useATPageIndex();
  const handlePageChange = (e: any) => {
    setPageIndex(e.page);
  };
  const { pageSize } = useATPageSize();

  return (
    <Pagination.Root
      count={totalItemsCount}
      pageSize={pageSize}
      page={pageIndex}
      onPageChange={handlePageChange}
    >
      <ButtonGroup variant="ghost" size="sm" wrap="wrap">
        <Pagination.PrevTrigger asChild>
          <IconButton>
            <LuChevronLeft />
          </IconButton>
        </Pagination.PrevTrigger>

        <Pagination.Items
          render={(page) => (
            <IconButton
              variant="ghost"
              color={{ base: 'fg.subtle', _selected: 'accent1.fg' }}
              // variant={ { base: 'ghost', _selected: 'outline' } }
            >
              {page.value}
            </IconButton>
          )}
        />

        <Pagination.NextTrigger asChild>
          <IconButton>
            <LuChevronRight />
          </IconButton>
        </Pagination.NextTrigger>
      </ButtonGroup>
    </Pagination.Root>
  );
};

export default ATPagination;
